/**
 * Silence the "Uncaught (in promise) {status: null, body: null, json: null, errors: null}"
 * console spam that Livewire produces when its polling/setInterval requests fail because
 * the server is unreachable (offline mode, or SW returning a 503 fallback for /livewire/*).
 *
 * Livewire still retries on the next interval — we only stop the unhandled-rejection
 * from reaching the console. Any real error (with a non-null status, real exception,
 * etc.) is left untouched.
 */
window.addEventListener('unhandledrejection', (event) => {
    const r = event.reason;

    if (
        r &&
        typeof r === 'object' &&
        'status' in r &&
        'body' in r &&
        'json' in r &&
        'errors' in r &&
        r.status === null
    ) {
        event.preventDefault();
    }
});
